import { render, staticRenderFns } from "./PerformanceWidget.vue?vue&type=template&id=5f8f6abb&scoped=true"
import script from "./PerformanceWidget.vue?vue&type=script&lang=js"
export * from "./PerformanceWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8f6abb",
  null
  
)

export default component.exports